import React from 'react';

import { Container, Image } from 'react-bootstrap';

import welcomeLogo from 'assets/welcome-logo.png';
import { Footer } from 'components/UI';

/**
 * The login surface: a single centred column, with the footer inline beneath it rather than pinned
 * to the viewport, so the divider above it lines up with the column.
 */
const OauthWrapper = (props: { children: React.ReactNode }) => (
  <Container
    id="Oauth"
    fluid
    className="min-vh-100 bg-blue-login d-flex flex-column align-items-center justify-content-center py-5"
  >
    <div style={{ width: '100%', maxWidth: 480 }}>
      <Image className="logo mb-5 d-block mx-auto" src={welcomeLogo} fluid />
      {props.children}
      <Footer inline />
    </div>
  </Container>
);

export default OauthWrapper;
